module.exports = {
    SOLUTIONS: {
        WEBSITE: {
            label: 'Insurance Agency Website',
            description: 'An amazing website with everything your agency needs to attract and convert insurance buyers online.',
            price: 170,
        },
        LLM: {
            label: 'Local Listing Management',
            description: 'Get found across the web so consumers can reach your agency, with or without visiting your website.',
            // requires: [
            //     'WEBSITE',
            // ],
            price: 50,
        },
        SMM: {
            label: 'Social Media Marketing',
            description: 'Tell your story and build relationships with BrightFire\'s Social Media Marketing.',
            price: 100,
        },
        PPC: {
            label: 'Search Engine Marketing',
            description: 'Improve your online visibility, increase engagement, boost brand awareness, and most importantly, encourage your online prospects to take action.',
            price: 160,
        },
        RRM: {
            label: 'Reviews & Reputation Management',
            description: 'Grow, nurture, and protect your agency\'s online reputation.',
            // requires: [
            //     'WEBSITE',
            // ],
            price: 110,
        },
        SEO_BUNDLE: {
            label: 'Ultimate SEO Bundle',
            description: '',
            includes: [ 'WEBSITE', 'LLM', 'RRM' ],
            price: 290,
            savings: 40,
        },
    },
    ORDER: [
        'SEO_BUNDLE',
        'WEBSITE',
        'LLM',
        'SMM',
        'PPC',
        'RRM',
    ],
    ENDPOINTS: {
        email: process.env.REACT_APP_EMAIL_ENDPOINT,
        log: process.env.REACT_APP_QUOTE_LOG_ENDPOINT,
        quote: process.env.REACT_APP_QUOTE_GET_ENDPOINT,
    },
    REF: {
        checkoutBase: process.env.REACT_APP_CHECKOUT_BASE
    }
};
